import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgIf, DecimalPipe } from '@angular/common';
import { AdminBooking } from '../../../../model/admin.models';

@Component({
  selector: 'app-booking-card',
  standalone: true,
  imports: [NgIf, DecimalPipe],
  templateUrl: './booking-card.component.html',
  styleUrls: ['./booking-card.component.scss']
})
export class BookingCardComponent {
  @Input({ required: true }) booking!: AdminBooking;
  @Output() open = new EventEmitter<number>();

  get totalPassengers(): number {
    const p = this.booking.passengersCount;
    return (p.adult || 0) + (p.children || 0) + (p.infant || 0);
  }
}
